import React, { useContext } from "react";
import { UserProfile } from "@clerk/clerk-react";
import { SharedHorizontalTabs } from "../../shared";
import CorrespondenceSettings from "../Correspondence/CorrespondenceSettings";
import { ThemeContext } from "../../../context/ThemeContext";

const TABS = [
  { key: "account", label: "Account Settings" },
  { key: "personal", label: "Personal Settings" },
];

function Settings() {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { currentTabIndex, setSearchParams } =
    SharedHorizontalTabs.useGetTabIndex(TABS);

  const handleTabChange = (index) => {
    setSearchParams({ tab: TABS[index].key }, { replace: true });
  };

  return (
    <div
      className="flex flex-col h-full p-[24px] gap-y-[24px] bg-dupontCream dark:bg-darkPrimary text-dupontBlue dark:text-darkText"
    >
      <div className="flex flex-col items-center text-center">
        <h1 className="text-[42px] font-display font-bold mb-[12px]">
          Settings
        </h1>
        <div className="w-[80px] h-[1px] bg-dupontGold"></div>
      </div>

      {/* Appearance: moved here from the sidebar (Sam, 2026-09-26). */}
      <div className="flex flex-row items-center justify-center gap-x-[12px]" role="group" aria-label="Appearance">
        <span className="font-body text-[15px]">Appearance:</span>
        {[
          { key: "light", label: "☀ Light" },
          { key: "dark", label: "☾ Dark" },
        ].map((opt) => (
          <button
            key={opt.key}
            type="button"
            aria-pressed={theme === opt.key}
            onClick={() => theme !== opt.key && toggleTheme()}
            className={`rounded-full px-[14px] py-[4px] text-[15px] border border-dupontGold/70 transition-colors ${
              theme === opt.key
                ? "bg-dupontGold text-white"
                : "bg-transparent hover:bg-dupontGold/15"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
      <SharedHorizontalTabs.Component
        tabs={TABS.map((tab) => tab.label)}
        initialIndex={currentTabIndex}
        onChange={handleTabChange}
      />

      {/* Account Settings — Clerk's built-in profile manager */}
      {currentTabIndex === 0 && (
        <div className="flex flex-col w-full items-center justify-center">
          <UserProfile routing="path" path="/settings" />
        </div>
      )}

      {/* Personal Settings — correspondence, directory, and notification toggles */}
      {currentTabIndex === 1 && (
        <div className="flex flex-col w-full items-center">
          <CorrespondenceSettings showSocialSettings />
        </div>
      )}
    </div>
  );
}

export default Settings;
